import { motion, useReducedMotion } from "framer-motion";
import { Rich } from "@/components/common/Rich";
import { EASE } from "./Reveal";

// Signature on-load moment: each headline line rises out of its own mask.
export const MaskedLines = ({ lines = [], as = "h1", className = "", delay = 0.15, testId }) => {
  const reduce = useReducedMotion();
  const Tag = as;
  return (
    <Tag className={className} data-testid={testId}>
      {lines.map((line, i) => (
        <span key={i} className="-mb-[0.12em] block overflow-hidden pb-[0.12em]">
          <motion.span
            className="block will-change-transform"
            initial={reduce ? false : { y: "108%", rotate: 2 }}
            animate={{ y: "0%", rotate: 0 }}
            transition={{ duration: 1.1, ease: EASE, delay: delay + i * 0.12 }}
          >
            <Rich text={line} />
          </motion.span>
        </span>
      ))}
    </Tag>
  );
};
